module.exports = __webpack_public_path__ + "img/home-bg.d16acace.png";